{
    "A fresh verification link has been sent to your email address.": "Er is een nieuwe verificatielink naar je e-mailadres verstuurd.",
    "Are you sure you want to update this :question": "Weet je zeker dat je dit wilt bijwerken: :question",
    "All rights reserved.": "Alle rechten voorbehouden.",
    "Before proceeding, please check your email for a verification link.": "Om verder te gaan, check je e-mail voor een verificatielink.",
    "click here to request another": "vraag hier een andere aan",
    "Confirm Password": "Bevestig wachtwoord",
    "Docs": "Documentatie",
    "E-Mail Address": "E-mailadres",
    "Error": "Fout",
    "Forbidden": "Geen toegang",
    "Forgot Your Password?": "Wachtwoord vergeten?",
    "Go Home": "Terug naar de voorpagina",
    "Hello!": "Hallo!",
    "hi": "hallo",
    "If you did not create an account, no further action is required.": "Als je geen account hebt aangemaakt hoef je verder niets te doen.",
    "If you did not receive the email": "Als je de e-mail niet hebt ontvangen:",
    "If you did not request a password reset, no further action is required.": "Als je geen wachtwoordherstel hebt aangevraagd, hoef je verder niets te doen.",
    "If you’re having trouble clicking the \":actionText\" button, copy and paste the URL below\ninto your web browser:": "Als je problemen hebt met de \":actionText\" knop, kopieer en plak de URL hieronder\nin je webbrowser:",
    "Invalid signature.": "Ongeldige handtekening.",
    "Login": "Inloggen",
    "Logout": "Uitloggen",
    "Name": "Naam",
    "Not Found": "Niet gevonden",
    "Oh no": "Oh nee",
    "Page Expired": "Pagina niet meer geldig",
    "Page Not Found": "Pagina niet gevonden",
    "Password": "Wachtwoord",
    "Send Password Mail": "Stuur mail om wachtwoord in te stellen",
    "Leave empty to keep current password": "Laat leeg om huidig wachtwoord te behouden",
    "Patient number": "Patiëntnummer",
    "Please click the button below to verify your email address.": "Klik op de knop hieronder om je e-mailadres te verifiëren.",
    "Please confirm your password before continuing.": "Bevestig je wachtwoord om verder te gaan.",
    "Regards": "Met vriendelijke groet",
    "Regards,": "Met vriendelijke groet,",
    "If you're having trouble clicking the \":actionText\" button, copy and paste the URL below\ninto your web browser:": "Als je problemen ondervindt bij het klikken op de knop \":actionText\", kopieer en plak dan de onderstaande URL in je webbrowser:",
    "Register": "Registreren",
    "Remember Me": "Onthoud mij",
    "Reset Password": "Wachtwoord herstellen",
    "Reset Password Notification": "Wachtwoordherstel notificatie",
    "Send Password Reset Link": "Verstuur link voor wachtwoordherstel",
    "Server Error": "Server fout",
    "Service Unavailable": "Website onbeschikbaar",
    "Sorry, the page you are looking for could not be found.": "Sorry, deze pagina kon niet gevonden worden.",
    "Sorry, you are forbidden from accessing this page.": "Sorry, je mag deze pagina niet opvragen.",
    "Sorry, you are making too many requests to our servers.": "Sorry, je doet teveel aanvragen naar onze servers.",
    "Sorry, you are not authorized to access this page.": "Sorry, je hebt geen toegang tot deze pagina.",
    "Sorry, your session has expired. Please refresh and try again.": "Sorry, je sessie is verlopen. Herlaad de pagina en probeer het opnieuw.",
    "Sorry, we are doing some maintenance. Please check back soon.": "Sorry, we zijn op dit moment bezig met onderhoud. Probeer het straks nog eens.",
    "This password reset link will expire in :count minutes.": "Deze link om je wachtwoord te herstellen verloopt over :count minuten.",
    "Toggle navigation": "Schakel navigatie",
    "Too Many Attempts.": "Te veel pogingen.",
    "Too Many Requests": "Te veel serververzoeken",
    "Unauthorized": "Onbevoegd",
    "Verify Email Address": "Verifieer e-mailadres",
    "Verify Your Email Address": "Verifieer je e-mailadres",
    "We won't ask for your password again for a few hours.": "We zullen je de komende uren niet nogmaals om je wachtwoord vragen.",
    "You are receiving this email because we received a password reset request for your account.": "Je ontvangt deze e-mail omdat we een wachtwoordherstel verzoek hebben ontvangen voor je account.",
    "Your email address is not verified.": "Je e-mailadres is niet geverifieerd.",
    "Whoops!": "Oeps!",
    "Whoops, something went wrong on our servers.": "Oeps, er ging iets fout op onze servers.",
    "This action is unauthorized.": "Deze actie is niet toegestaan.",
    "The :attribute has been used in the past %d hours.": ":attribute is al gebruikt in de afgelopen %d uur.",
    "(empty)": "(leeg)",
    "Search ...": "Zoeken ...",
    "__WelcomeMail": "",
    "Welcome": "Welkom",
    "You are receiving this email because an account was created for you.": "Je ontvangt deze mail omder er een account voor je is aangemaakt",
    "Set initial password": "Stel je wachtwoord in",
    "This welcome link will expire in :count hours.": "Deze link verloopt over :count uur.",
    "__Multiselect": "",
    "Select option": "Selecteer optie",
    "Press enter to select": "Druk op enter om te selecteren",
    "Press enter to select group": "Druk op enter om groep te selecteren",
    "Selected": "Geselecteerd",
    "Press enter to remove": "Druk op enter om te verwijderen",
    "Press enter to deselect group": "Druk op enter om groep te verwijderen",
    "Maximum of :max options selected. First remove a selected option to select another": "Maximum van :max opties geselecteerd. Verwijder eerst een optie om een andere te selecteren.",
    "No elements found. Consider changing the search query.": "Kies een waarde uit de lijst, andere waarden zijn niet mogelijk.",
    "List is empty.": "Geen opties gevonden.",
    "__Navigation": "",
    "Access": "Toegang",
    "Audit Log": "Logboek",
    "__General": "",
    "Create": "Nieuw",
    "Update": "Update",
    "Previous": "Vorige",
    "Next": "Volgende",
    "Save": "Opslaan",
    "Search…": "Zoeken…",
    "Page": "Pagina",
    "Add": "Voeg toe",
    "Remove": "Haal weg",
    "Yes": "Ja",
    "No": "Nee",
    "Dutch": "Nederlands",
    "English": "Engels",
    "New": "Nieuw",
    "Not all questions are filled correctly.": "Niet alle vragen zijn correct ingevuld.",
    "Thanks for filling in the questionnaire.": "Bedankt voor het invullen van de vragenlijst. Uw antwoorden zijn doorgestuurd naar de pre-operatieve poli van het Maastricht UMC+. Zij nemen binnenkort contact met u op.",
    "There are no questions.": "Er zijn geen vragen.",
    "__Users": "",
    "User": "Gebruiker",
    "Users": "Gebruikers",
    "Create User": "Nieuwe gebruiker",
    "Update User": "Update gebruiker",
    "Delete User": "Verwijder gebruiker",
    "Are you sure you want to delete this user?": "Weet je zeker dat je deze gebruiker wilt verwijderen?",
    "No users found.": "Geen gebruikers gevonden",
    "__Profile": "",
    "Profile": "Profiel",
    "Account created": "Account aangemaakt",
    "Never": "Nooit",
    "No roles assigned": "Geen rollen toegewezen",
    "__Roles": "",
    "Role": "Rol",
    "Roles": "Rollen",
    "Create Role": "Nieuwe rol",
    "Update Role": "Update rol",
    "Delete Role": "Verwijder rol",
    "Are you sure you want to delete this role?": "Weet je zeker dat je deze rol wilt verwijderen?",
    "No roles found.": "Geen rollen gevonden",
    "Permissions": "Rechten",
    "__Forms": "",
    "Form": "Formulier",
    "Forms": "Formulieren",
    "Language": "Taal",
    "Create Form": "Nieuw formulier",
    "Edit Form": "Bewerk formulier",
    "Update Form": "Update formulier",
    "Delete Form": "Verwijder formulier",
    "Version": "Versie",
    "File": "Bestand",
    "Filename": "Bestandsnaam",
    "Tabs": "Tabs",
    "Add tab": "Tab toevoegen",
    "Decision Versions": "Beslissing Versies",
    "New Version": "Nieuwe versie",
    "Add Version": "Versie toevoegen",
    "Refresh from CDM": "Vernieuwen vanuit CDM",
    "Refresh from file": "Nieuw bestand laden",
    "Create Version": "Nieuwe versie",
    "No forms found.": "Geen formulieren gevonden.",
    "No versions found.": "Geen versies gevonden.",
    "No :name.": "Geen :name.",
    "Nothing here yet.": "Nog niets ingevuld.",
    "Source": "Bron",
    "__FormGroups": "",
    "Form Group": "Formulier groep",
    "Form Groups": "Formulier groepen",
    "Create Form Group": "Nieuwe formulier groep",
    "Delete Form Group": "Verwijder formulier groep",
    "Update Form Group": "Update formulier groep",
    "No form groups found.": "Geen formulier groepen gevonden.",
    "__Invites": "",
    "Invite": "Uitnodiging",
    "Invite uuid or short uuid": "Uuid of korte uuid van de uitnodiging",
    "Invites": "Uitnodigingen",
    "Create :invite": "Nieuwe :invite",
    "Import :invite": "Importeer :invite",
    "Import as new :invite": "Importeer als nieuwe :invite",
    "Recalculate all :invites": "Herbereken alle :invites",
    "Refreshing, :left :invites left.": "Herberekenen, nog :left :invites.",
    "Refresh finished, :succeeded succeeded, :failed failed.": "Herberekenen geslaagd, :succeeded gelukt, :failed gefaald.",
    "No form selected": "Geen formulier geselecteerd",
    "Form Name": "Formulier",
    "Form Group Name": "Formulier groep",
    "Link": "Link",
    "Created": "Aangemaakt",
    "Started": "Gestart",
    "Printed": "Afgedrukt",
    "Updated": "Aangepast",
    "Completed": "Voltooid",
    "Show everything": "Toon alle",
    "Only not completed": "Alleen openstaande",
    "Only completed": "Alleen afgeronde",
    "Less than": "tot en met",
    "Equals": "gelijk aan",
    "Greater than": "vanaf",
    "No invites found.": "Geen uitnodigingen gevonden.",
    "Link copied to clipboard": "Link gekopieerd",
    "Text copied to clipboard": "Tekst gekopieerd",
    "Birth date": "Geboortedatum",
    "Get PDF": "Bekijk PDF",
    "Get Intake PDF": "Bekijk Vragenlijst PDF",
    "Are you sure you want to delete this invite?": "Weet je zeker dat je deze uitnodiging wilt verwijderen?",
    "Show data and explanation": "Toon data en uitleg",
    "Show tables": "Toon tabellen",
    "High Priority Mail": "Hoge Prioriteit Mail",
    "Force Send": "Negeer waarschuwingen",
    "__Exports": "",
    "Import": "Importeer",
    "Import/Export": "Importeren/Exporteren",
    "Import & Export": "Import & Export",
    "Export": "Exporteer",
    "Export Evaluations": "Exporteer Evaluaties",
    "Export Batch": "Exporteer Batch",
    "Create Batch Import": "Nieuwe Batch Import",
    "No batch imports found.": "Geen batch imports gevonden.",
    "No imports found.": "Geen imports gevonden.",
    "Differences found": "Verschillen gevonden",
    "No differences found": "Geen verschillen gevonden",
    "Ignored Attributes": "Genegeerde attributen",
    "Go to :invite": "Ga naar :invite",
    "evaluations.xlsx": "evaluaties.xlsx",
    "pending": "wachten",
    "processing": "verwerken",
    "completed": "voltooid",
    "failed": "mislukt",
    "__Files": "",
    "Files": "Bestanden",
    "Browse": "Bladeren",
    "Drag files here or click to browse": "Sleep bestanden hierheen of klik om te browsen",
    "No files found": "Er zijn geen bestanden gevonden",
    "A file with the name [:value] already exists": "Een bestand met de naam [:value] bestaat al",
    "Are you sure you want to remove this file?": "Weet je zeker dat je dit bestand wilt verwijderen?",
    "__Settings": "",
    "Settings": "Instellingen",
    "Update Settings": "Update",
    "Saving...": "Opslaan...",
    "All changes saved": "Alle wijzigingen opgeslagen",
    "Could not save changes": "Opslaan mislukt",
    "Experimental features": "Experimentele functies",
    "System information": "Systeeminfo",
    "Site Name": "Site naam",
    "Invite Name": "Naam uitnodiging",
    "Invite Name Plural": "Naam uitnodiging (meervoud)",
    "Show Breadcrumbs": "Toon breadcrumbs",
    "Show PDF Screen": "Toon pdf scherm",
    "Enable Decision Service": "Beslissingsservice inschakelen",
    "Enable simplified tables": "Eenvoudige weergeve uitlegtabel",
    "Link Expiration (days)": "Link vervalt na (dagen)",
    "Refresh Invite Rate Limit (per second)": "Limiet voor herberekenen (per seconde)",
    "Clear Cache": "Cache legen",
    "Cache cleared!": "Cache geleegd!",
    "Actions": "Acties",
    "Back to form": "Terug naar formulier",
    "details": "details",
    "Failed": "Mislukt",
    "Import completed": "Import voltooid",
    "Import failed": "Import mislukt",
    "Import log": "Importlog",
    "Importing form version": "Formulierversie importeren",
    "Processing": "Bezig",
    "Queued for import": "In wachtrij voor import",
    "Queued": "In wachtrij",
    "Status": "Status",
    "View import logs": "Importlogs bekijken",
    "Update all invites to this version": "Alle uitnodigingen bijwerken naar deze versie",
    "Update Exportable Questions": "Exportbare vragen bijwerken",
    "Download Excel": "Download Excel",
    "Export to Excel": "Export naar Excel",
    "Export to YAML": "Export naar YAML",
    "Waiting for the import to start...": "Wachten tot de import start...",
    "Form versions updated": "Formulier versies bijgewerkt",
    "Forms are managed by the init file and cannot be changed.": "Formulieren worden beheerd door het init-bestand en kunnen niet worden gewijzigd.",
    "Form groups are managed by the init file and cannot be changed.": "Formuliergroepen worden beheerd door het init-bestand en kunnen niet worden gewijzigd.",
    "Managed by the init file": "Beheerd door het init-bestand",
    "Editor": "Editor",
    "Edit": "Bewerken",
    "Preview": "Voorbeeld",
    "Loading preview…": "Voorbeeld laden…",
    "Saving…": "Opslaan…",
    "Save failed": "Opslaan mislukt",
    "Could not save your changes. Please check your edits and try again.": "Kon je wijzigingen niet opslaan. Controleer je aanpassingen en probeer opnieuw.",
    "Structure": "Structuur",
    "Questions": "Vragen",
    "Block": "Blok",
    "Block title": "Bloktitel",
    "Title": "Titel",
    "Text": "Tekst",
    "Text area": "Tekstvak",
    "Number": "Nummer",
    "Date": "Datum",
    "Multiple choice": "Meerkeuze",
    "Checkbox": "Selectievakje",
    "Yes / No": "Ja / Nee",
    "Dropdown": "Keuzelijst",
    "Column": "Kolom",
    "Empty block — drag or add a question here": "Leeg blok — sleep of voeg hier een vraag toe",
    "Drag block": "Sleep blok",
    "Default block state": "Standaard blokstand",
    "Default collapsed": "Standaard ingeklapt",
    "Default expanded": "Standaard uitgeklapt",
    "Block settings": "Blok info",
    "Default state": "Standaardstand",
    "Delete this block and all its questions?": "Dit blok en alle vragen erin verwijderen?",
    "Edit details": "Details bewerken",
    "Close": "Sluiten",
    "OK": "OK",
    "Hidden": "Verborgen",
    "Show all blocks": "Alle blokken tonen",
    "Columns": "Kolommen",
    "Enable column": "Kolom inschakelen",
    "auto": "auto",
    "Pin this column so it stays in view while scrolling": "Kolom vastzetten zodat hij in beeld blijft tijdens het scrollen",
    "Hide this tab from respondents": "Tab verbergen voor invullers",
    "Always show every block, ignoring decision logic": "Altijd elk blok tonen, ongeacht de beslislogica",
    "Restrict this tab to roles": "Beperk deze tab tot rollen",
    "No roles available": "Geen rollen beschikbaar",
    "Delete tab": "Tab verwijderen",
    "Delete this tab and all its questions?": "Deze tab en alle vragen erin verwijderen?",
    "Hide tab settings": "Tab-info verbergen",
    "Untitled": "Naamloos",
    "required": "verplicht",
    "Edited via import/YAML": "Bewerkt via import/YAML",
    "Input field": "Invoerveld",
    "Heading": "Kop",
    "Layout element": "Lay-outelement",
    "Other": "Overig",
    "Question": "Vraag",
    "This question type is edited via import/YAML.": "Dit vraagtype wordt bewerkt via import/YAML.",
    "Description": "Omschrijving",
    "Hint": "Hint",
    "Variable name": "Variabelenaam",
    "Required": "Verplicht",
    "Type": "Type",
    "Answer type": "Antwoordtype",
    "Tab": "Tab",
    "Expressies": "Expressies",
    "Variabelen": "Variabelen",
    "Alle": "Alle",
    "Antwoorden": "Antwoorden",
    "Overig": "Overig",
    "Geen variabelen.": "Geen variabelen.",
    "Variabele toevoegen": "Variabele toevoegen",
    "Variabele bewerken": "Variabele bewerken",
    "Antwoord bewerken": "Antwoord bewerken",
    "naam": "naam",
    "type": "type",
    "expressie": "expressie",
    "geen expressie": "geen expressie",
    "service": "service",
    "data-id": "data-id",
    "Waar gebruikt": "Waar gebruikt",
    "gebruikt in": "gebruikt in",
    "Ga naar :section": "Ga naar :section",
    "in": "in",
    "in een herhalend blok": "in een herhalend blok",
    "Let op: dubbele namen (de laatste overschrijft de eerste):": "Let op: dubbele namen (de laatste overschrijft de eerste):",
    "Waardelijsten": "Waardelijsten",
    "CDM-services": "CDM-services",
    "Nog geen CDM-services.": "Nog geen CDM-services.",
    "CDM-service toevoegen": "CDM-service toevoegen",
    "CDM-service bewerken": "CDM-service bewerken",
    "Metadata": "Metadata",
    "Metadata laden": "Metadata laden",
    "Nog geen metadata geladen.": "Nog geen metadata geladen.",
    "Enumeraties": "Enumeraties",
    "Attributen": "Attributen",
    "(geen url)": "(geen url)",
    "Value list": "Waardelijst",
    "— none —": "— geen —",
    "This list has no options.": "Deze lijst heeft geen opties.",
    "Variable name :name is already in use.": "Variabelenaam :name is al in gebruik.",
    "Value list key :key is already in use.": "Sleutel :key is al in gebruik.",
    "Min": "Min",
    "Max": "Max",
    "Regex": "Regex",
    "Show expression": "Toon-expressie",
    "Validation expression": "Validatie-expressie",
    "Delete": "Verwijderen",
    "Select a question to edit it": "Selecteer een vraag om te bewerken",
    "Edit question": "Vraag bewerken",
    "Advanced": "Geavanceerd",
    "Hide advanced": "Geavanceerd verbergen",
    "Read-only": "Alleen-lezen",
    "Width": "Breedte",
    "Inline": "Inline",
    "Background": "Achtergrond",
    "Border": "Rand",
    "Default value": "Standaardwaarde",
    "Regex message": "Regex-bericht",
    "e.g. vraag_1 == 'yes'": "bijv. vraag_1 == 'ja'",
    "Question :number moved to another block but is referenced in an expression — check your logic.": "Vraag :number is naar een ander blok verplaatst maar wordt gebruikt in een expressie — controleer je logica.",
    "Last saved just now": "Zojuist opgeslagen",
    "Last saved at :time": "Laatst opgeslagen om :time",
    "Last login": "Laatst ingelogd",
    "Naam": "Naam",
    "Antwoordtype": "Antwoordtype",
    "Expressie": "Expressie",
    "Bloknummer": "Bloknummer",
    "In toelichting": "In toelichting",
    "DSS data id": "DSS data id",
    "DSS service id": "DSS service id",
    "DSS-bron": "DSS-bron",
    "DSS-bron wissen": "DSS-bron wissen",
    "Kan attributen niet laden.": "Kan attributen niet laden.",
    "Verwijderen": "Verwijderen",
    "Expressie toevoegen": "Expressie toevoegen",
    "Expressie bewerken": "Expressie bewerken",
    "(naamloos)": "(naamloos)",
    "Nog geen expressies.": "Nog geen expressies.",
    "Opgeslagen": "Opgeslagen",
    "Opslaan mislukt": "Opslaan mislukt",
    "Nog geen waardelijsten.": "Nog geen waardelijsten.",
    "Sleutel": "Sleutel",
    "CDM service url": "CDM service url",
    "Enumeratie id": "Enumeratie id",
    "CDM attribuut": "CDM attribuut",
    "Opties": "Opties",
    "Waarde": "Waarde",
    "Label": "Label",
    "Optie toevoegen": "Optie toevoegen",
    "Waardelijst toevoegen": "Waardelijst toevoegen",
    "(geen sleutel)": "(geen sleutel)",
    "opties": "opties",
    "Waardelijst bewerken": "Waardelijst bewerken",
    "Attribuut": "Attribuut",
    "CDM-bron": "CDM-bron",
    "CDM-bron wissen": "CDM-bron wissen",
    "Enumeratie": "Enumeratie",
    "Kan enumeraties niet laden.": "Kan enumeraties niet laden.",
    "Kan opties niet laden.": "Kan opties niet laden.",
    "Laden": "Laden",
    "Laden...": "Laden...",
    "Nog geen opties geladen.": "Nog geen opties geladen.",
    "Ophalen uit CDM": "Ophalen uit CDM",
    "Opties worden beheerd via CDM.": "Opties worden beheerd via CDM.",
    "Service URL": "Service URL",
    "Cancel": "Annuleren",
    "Delete all filtered :invites": "Alle gefilterde :invites verwijderen",
    "Delete :count :invites": ":count :invites verwijderen",
    "You are about to delete :count :invites: every result matching the current filter, across ALL pages, not only the rows shown on this page.": "Je staat op het punt :count :invites te verwijderen: ALLE resultaten die aan het huidige filter voldoen, over alle pagina's, dus niet alleen de rijen op deze pagina.",
    ":count invites deleted": ":count uitnodigingen verwijderd",
    "Undo this import?": "Deze import ongedaan maken?",
    "Delete import": "Import verwijderen",
    "This deletes import :name and the :count invites it created. Invites that already existed before the import are kept, but keep the imported values.": "Dit verwijdert import :name en de :count uitnodigingen die door deze import zijn aangemaakt. Uitnodigingen die al bestonden voor de import blijven staan, maar behouden de geïmporteerde waarden.",
    "Import deleted, :count invites removed": "Import verwijderd, :count uitnodigingen verwijderd",
    "Enlarge table": "Tabel vergroten",
    "Back": "Terug",
    "The assistant request failed.": "Het verzoek aan de assistent is mislukt.",
    "The assistant is already working on this form.": "De assistent is al bezig met dit formulier.",
    "Only a request with a snapshot can be reverted.": "Alleen een verzoek met een momentopname kan worden teruggedraaid.",
    "The assistant stopped with an error. Changes made before the error are kept and can be reverted.": "De assistent is gestopt door een fout. Wijzigingen van voor de fout blijven bewaard en kunnen worden teruggedraaid.",
    "The assistant took too long and was stopped. Changes made before that are kept and can be reverted.": "De assistent deed er te lang over en is gestopt. Wijzigingen van daarvoor blijven bewaard en kunnen worden teruggedraaid.",
    "Could not save your latest changes; the assistant was not started.": "Je laatste wijzigingen konden niet worden opgeslagen; de assistent is niet gestart.",
    "AI": "AI",
    "AI assistant": "AI-assistent",
    "Ask the assistant to change this draft, for example to add the inputs of a CDM service.": "Vraag de assistent dit concept aan te passen, bijvoorbeeld om de invoer van een CDM-service toe te voegen.",
    "Ask the assistant…": "Vraag het de assistent…",
    "Send": "Versturen",
    "Working…": "Bezig…",
    "Reverted": "Teruggedraaid",
    "Changes: :count": "Wijzigingen: :count",
    "Revert": "Terugdraaien",
    "Revert this request?": "Dit verzoek terugdraaien?",
    "This restores the form to how it was before this request. Later requests and edits made since then are also undone.": "Dit zet het formulier terug naar hoe het was vóór dit verzoek. Latere verzoeken en wijzigingen die sindsdien zijn gedaan, worden ook ongedaan gemaakt.",
    ":tool failed": ":tool mislukt",
    "Adding a block…": "Blok toevoegen…",
    "Adding CDM inputs…": "CDM-invoer toevoegen…",
    "Adding a question…": "Vraag toevoegen…",
    "Adding a tab…": "Tabblad toevoegen…",
    "Deleting CDM service…": "CDM-service verwijderen…",
    "Deleting a question…": "Vraag verwijderen…",
    "Deleting a tab…": "Tabblad verwijderen…",
    "Deleting a value list…": "Waardelijst verwijderen…",
    "Deleting a variable…": "Variabele verwijderen…",
    "Looking for missing CDM inputs…": "Ontbrekende CDM-invoer zoeken…",
    "Flattening one-to-one blocks…": "Een-op-een-blokken platslaan…",
    "Reading CDM enumeration values…": "CDM-enumeratiewaarden lezen…",
    "Reading the form…": "Formulier lezen…",
    "Reading a question…": "Vraag lezen…",
    "Reading CDM attributes…": "CDM-attributen lezen…",
    "Reading CDM enumerations…": "CDM-enumeraties lezen…",
    "Reading CDM services…": "CDM-services lezen…",
    "Reading value lists…": "Waardelijsten lezen…",
    "Reading variables…": "Variabelen lezen…",
    "Moving a question…": "Vraag verplaatsen…",
    "Renaming a tab…": "Tabblad hernoemen…",
    "Switching CDM service…": "CDM-service wisselen…",
    "Updating a question…": "Vraag bijwerken…",
    "Saving CDM service…": "CDM-service opslaan…",
    "Saving a value list…": "Waardelijst opslaan…",
    "Saving a variable…": "Variabele opslaan…",
    "The connection to the assistant was lost.": "De verbinding met de assistent is verbroken.",
    "The latest version of the form could not be loaded. Reload the page before editing further.": "De nieuwste versie van het formulier kon niet worden geladen. Herlaad de pagina voordat je verder bewerkt.",
    "No reply was stored for this request.": "Voor dit verzoek is geen antwoord opgeslagen.",
    "The assistant is working on this form… The editor unlocks when it is done.": "De assistent is bezig met dit formulier… De editor wordt weer vrijgegeven als hij klaar is.",
    "No AI provider key is configured for this application. Ask an administrator to set one.": "Er is geen sleutel voor de AI-dienst ingesteld voor deze applicatie. Vraag een beheerder om er een in te stellen.",
    "No AI provider key is configured for this application.": "Er is geen sleutel voor de AI-dienst ingesteld voor deze applicatie.",
    ":name is using the assistant on this form… The editor unlocks when it is done.": ":name gebruikt de assistent op dit formulier… De editor wordt weer vrijgegeven als hij klaar is.",
    ":name is using the assistant on this form. The editor is locked until it is done.": ":name gebruikt de assistent op dit formulier. De editor is vergrendeld tot hij klaar is.",
    "The assistant is working on this form. Publish it once it is done.": "De assistent is bezig met dit formulier. Publiceer het als hij klaar is.",
    "This request has already been reverted.": "Dit verzoek is al teruggedraaid."
}
